<div class="row text-white footer-section">
  <div class="col-12 p-3">
    <div class="card-details d-flex flex-wrap mt-2">
      <div class="mb-1">
        <small class="font-weight-bold mb-1">
          {{ "LandingPage.pay-online-heading" | translate }}
        </small>
        <br/>
        <small>
          {{ "LandingPage.pay-online-description" | translate }}
        </small>
      </div>
      <div class="mb-1">
        <small class="font-weight-bold mb-1">{{ "LandingPage.ach-debit-heading" | translate }}</small>
        <br/>
        <small>{{ "LandingPage.ach-debit-description" | translate }}</small>
      </div>
      <div class="mb-1">
        <small class="font-weight-bold mb-1">
          {{ "LandingPage.credit-card-heading" | translate }}
        </small>
        <br/>
        <small>
          {{ "LandingPage.credit-card-description" | translate: { processingFee, feeMinimum } }}
        </small>
        <br/>
        <small>
          {{ "LandingPage.credit-card-description-2" | translate }}

          '<strong>{{ "LandingPage.credit-card-description-2-heading"| translate }}</strong>.'
        </small>
      </div>
    </div>
  </div>
</div>
